import api from "../api"

export class PartnerService {
    static async listContract(status?: number[]) {
        return api.get("/contracts", {
            params: {
                status: (status ?? []).join(",")
            }
        })
    }

    static async getClients(search?: string) {
        return api.get("/users/clients", {
            params: {
                ... (search && {
                    search
                })
            }
        })
    }

    static async getMovements(accountId: number) {
        return api.get("/finance/accounts/movements/" + accountId)
    }

    static async list() {
        return api.get("/users/partners")
    }

    static async withdraw(body: {
        accountId: number,
        value?: number,
        toKey: 'cpf' | 'cnpj'
    }) {
        return api.post("/finance/accounts/withdraw", body)
    }
}